<form *ngIf="form" (ngSubmit)="onSubmit()" [formGroup]="form">
    <wuc-form-field>
        <wuc-form-field-label>Ingangsdatum</wuc-form-field-label>
        <wuc-input-date-picker [formControl]="endDate" id="endDate" [minDate]="minimumDate"></wuc-input-date-picker>
        <wuc-input-alert *ngIf="endDate.touched && endDate.hasError('required')" alertType="error" icon="cross-closed" [messages]="['Vul uw ingangsdatum in']"></wuc-input-alert>
        <wuc-form-field-subtext *ngIf="errors?.length > 0">
            <wuc-balloon backgroundStyle="secondary" arrowPosition="topLeft" padding="medium" [hasCloseIcon]="false" [isFullWidth]="true">
                <wuc-list icon="cross">
                    <ng-container *ngFor="let error of errors">
                        <wuc-list-item>{{ error.message }}</wuc-list-item>
                    </ng-container>
                </wuc-list>
            </wuc-balloon>
        </wuc-form-field-subtext>
    </wuc-form-field>
    <wuc-form-field>
        <wuc-form-field-label></wuc-form-field-label>
        <wuc-button [isSubmitButton]="true" [isFullWidth]="true" [disabled]="isDisabled">Opslaan</wuc-button>
    </wuc-form-field>
</form>
